import { z } from "zod";
export const UpdateRegion = z.object({
    publicId: z.string().uuid(),
    name: z.string().min(1).max(128),
});
//# sourceMappingURL=region.update.js.map